import { Component, ViewChild } from '@angular/core';
import { CurrencyPipe, ViewportScroller } from '@angular/common';

import utils from './../../utils';
import { AlertService, CryptoService, RouteDataProvider, ItemServiceProvider, RequestHelperProvider, DialogCloseService, StorageServiceProvider } from './../../_services/services';

import { CustomerCredit } from './../../_models/customer/customer-credit.model';
import { CustomerDetails } from '../../_models/customer/customer-details.model';
import { ItemRequest } from '../../_models/item/item-request.model';
import { ItemDetails } from '../../_models/item/item-details.model';
import { BookingRequest } from './../../_models/booking/booking-request.model';
import { CustomerRequest } from './../../_models/customer/customer-request.model';
import { GatewayServiceProvider } from '../../_services/gateway.service';
import { Title } from '@angular/platform-browser';
import { CustomerServiceProvider } from '../../_services/customer.service';
import { AppSettingsServiceProvider } from '../../_services/app-settings.service';
// import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Global } from 'src/app/globals';
// import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { OpenBookingComponent } from '../shared/open-bookings/open-booking.component';
import { OpenPrepaysComponent } from '../shared/open-prepays/open-prepays.component';
import { BookingServiceProvider } from 'src/app/_services/booking.service';
import * as Sentry from '@sentry/angular';
import { ASRAppSettings, CategoryType, GlobalConstants, PDFLinkPlaceHolder, PendingAgreementsConfiguration, StorageKeys, TransactionType } from 'src/app/_constants';
import { PendingAgreementConfig } from 'src/app/_models/booking/pending-agreement-config';
import { EmailContent } from 'src/app/_models/booking/email-content';
import { BookingPostingErrorTypes, ItemSearchType } from 'src/app/enums';
import Utils from './../../utils';
import { Helpers } from 'src/app/_models/helpers';
// import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatButton as MatButton } from '@angular/material/button';

import { compare } from 'compare-versions';
import { CustomEvents } from 'src/app/_services/custom-events';
import { CustomerSplitDetailsComponent } from '../shared/customer-splits-details/customer-splits-details.component';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { Router, ActivatedRoute } from '@angular/router';
import { QuoteComponent } from '../shared/quote/quote.component';
import { PrepayComponent } from '../shared/prepay/prepay.component';
import { BookComponent } from '../shared/book/book.component';
import { ItemListComponent } from '../shared/item-list/item-list.component';
import { ItemSearchComponent } from '../shared/item-search/item-search.component';
import { FarmAndFieldsComponent } from '../shared/farm-field/farm-field.component';
import { CustomerListComponent } from '../shared/customer-list/customer-list.component';
import { CustomerSearchComponent } from '../shared/customer-search/customer-search.component';
import { LoadingService } from 'src/app/_services/loading.service';
//import { ItemSearchComponent } from '../shared/item-search/item-search.component';

@Component({
    selector: 'app-booking',
    templateUrl: './booking.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule,
        QuoteComponent,
        PrepayComponent,
        BookComponent,
        ItemListComponent,
        ItemSearchComponent,
        FarmAndFieldsComponent,
        CustomerListComponent,
        CustomerSearchComponent
    ]
})



export class BookingComponent {
    private static readonly noOpSpan = { finish: () => undefined };
    @ViewChild('btnCreditCheckNext') btnCreditCheckNext: MatButton;
    //   @ViewChild('itemSearch') itemSearchComponent!: ItemSearchComponent;
    currentWidth: number;
    step = 0;

    totalItemsCount: number = 0;
    isSummaryDisable: boolean = true;

    isItemSearchDisable: boolean = true;
    bookingRequest: BookingRequest;
    bookingRequests: BookingRequest[];
    minDate: Date;

    dataSource: MatTableDataSource<ItemDetails>;
    displayedColumns: string[];

    selectedCustomer: CustomerDetails;
    customerRequest: CustomerRequest;
    credit: CustomerCredit;
    customerSearchDescription: string = 'Search Customers';
    customers: CustomerDetails[] = null;

    itemsDetails: ItemDetails[] = null;
    addedItems: ItemDetails[] = [];
    selectedItem: ItemDetails;
    showItemDetails: boolean = false;
    itemNameForDetails: string;
    customerLimitType: number;
    quoteBookingId: number;
    bookingId: number;

    isBookEnabled: boolean = false;
    isPrepayEnabled: boolean = false;
    isQuoteEnabled: boolean = false;
    isQuoteBooking: boolean = false;
    isQuoteUpdate: boolean = false;
    isFromQuote: boolean = false;
    isQuoteConvert: boolean = false;
    isBookAllow: boolean = false;
    isPrepayAllow: boolean = false;
    isByPhone: boolean = false;
    bookType: string;
    isItemAddDisable: boolean;
    productQuantityPrecision: number;
    unitPricePrecision: number;
    remarks: string = '';
    isAlert: boolean = false;
    defaultBankCode = '';
    signature: string = '';
    transaction: { finish?: () => void };
    customerPriceLevel: string;
    showBackToTopForCustomers: boolean = false;
    showBackToTopForItems: boolean = false;
    isPostInprogress: boolean = false;

    bookingProgramDropdownItems: any[] = [];
    bookingProgramDropdownStatus: boolean = false;
    bookingProgramDropdownRequired: string = "Required";

    BookingSignatureRequiredStatus: boolean = false;
    QuoteButtonName: string = "Quote";
    BookingButtonName: string = "Booking";
    PrepayButtonName: string = "Prepay"

    HideQuoteButton: boolean = false;
    HidePrepayButton: boolean = false;
    HideBookingButton: boolean = false;
    AgrisCurrentversion: string = "";
    AgrisUpdateAllowedVersion: string = "";
    AllowedEdit: boolean = false;
    remarksCommenLimit: number = 300;
    isAutoPostPrepay: boolean;
    isAutoApproveBooking: boolean;
    public myMath = Math;
    productCategoryDateRange: any[] = [];
    dontCallNgOnInit: boolean = false;
    isfarmAndFields: boolean = false;
    selectedFarmAndField: string;
    splits: [];
    isDifferentLocationItemSelected: boolean = false;

    public pendingAgreementConfig: PendingAgreementConfig = {
        pendingAgreementStatus: false,
        emailType: "",
        pendingBookingStatus: "",
        pendingBookingStatusDescription: "",
        pendingPrepayStatus: "",
        pendingPrepayStatusDescription: "",
        pendingOrderStatus: "",
        pendingOrderStatusDescription: "",
        pendingQuoteStatus: "",
        pendingQuoteStatusDescription: "",
        PendingSignatureRequiredStatus: false,
        ButtonQuote: "Quote",
        ButtonBooking: "Book",
        ButtonPrepay: "Prepay",
        SameBookingNumberConfig: false,
        RemarkNumberForFarmAndField: "",
        RemarkNumberForBookingProgram: "",
    };
    public emailContent: EmailContent;
    public mailToEmails: string;
    public currentNavigation: any;
    public ItemSearchType = ItemSearchType.Booking;
    public selectedItemLocations: any[] = [];
    public QuoteItemLocation: any[] = [];
    isProUser: boolean = false;
    public showFarmAndFields: boolean = false;
    private isHistoryCopyBootstrapInProgress: boolean = false;
    constructor(
        private gatewayService: GatewayServiceProvider,
        private customerServiceProvider: CustomerServiceProvider,
        private itemServiceProvider: ItemServiceProvider,
        private itemSerivce: ItemServiceProvider,
        public router: Router,
        private route: ActivatedRoute,
        public globals: Global,
        private alertService: AlertService,
        private cryptoService: CryptoService,
        private dataProvider: RouteDataProvider,
        private currencyPipe: CurrencyPipe,
        private appSetting: AppSettingsServiceProvider,
        private titleService: Title,
        private dialog: MatDialog,
        private bookingService: BookingServiceProvider,
        private gateway: GatewayServiceProvider,
        private scroll: ViewportScroller,
        private requestHelper: RequestHelperProvider,
        private closeDialogService: DialogCloseService,
        private storage: StorageServiceProvider,
        private events: CustomEvents,
        private blockUI: LoadingService
    ) {


        if (typeof this.router.getCurrentNavigation == "function")
            this.currentNavigation = this.router.getCurrentNavigation();

        if (this.route.snapshot.params['from'] === 'historycopy') {
            this.isHistoryCopyBootstrapInProgress = true;
            this.blockUI.start();
        }

        this.initialise();
        // this.titleService.setTitle("Booking");
    }

    private startBookingTransaction(name: string) {
        try {
            const sentryAny = Sentry as unknown as { startSpan?: (context: { name: string }) => { finish?: () => void } };
            const span = sentryAny.startSpan ? sentryAny.startSpan({ name }) : null;
            return span || BookingComponent.noOpSpan;
        } catch {
            return BookingComponent.noOpSpan;
        }
    }
    async initialise() {
        this.showFarmAndFields = false;
        this.selectedFarmAndField = 'Not Selected';
        this.AgrisCurrentversion = localStorage.getItem("AgrisVersion");
        this.AgrisUpdateAllowedVersion = "23.0.0";
        if (this.AgrisCurrentversion) {
            this.AllowedEdit = compare(this.AgrisCurrentversion, this.AgrisUpdateAllowedVersion, '>=');
        } else {
            this.AllowedEdit = compare('22.0.0', this.AgrisUpdateAllowedVersion, '>=');
        }
        this.isProUser = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? true : false

        if (this.settingsCheck()) {
            this.router.navigate(['settings']);
        }
        this.isPostInprogress = false;
        this.isDifferentLocationItemSelected = false;
        this.bookingRequest = new BookingRequest();
        this.bookingRequests = [];
        this.customerRequest = new CustomerRequest();
        this.selectedItem = new ItemDetails(utils.getLocation());
        this.currentWidth = window.innerWidth;
        this.credit = new CustomerCredit();
        this.setDefaultDates();
        this.getPermissions();

        this.blockUI.start();
        let settings = this.storage.get(StorageKeys.Settings);;
        await this.getPricision();
        await this.getDefaultBankCode(settings.locationCode);
        await this.GetBookingPrograms();
        await this.GetPendingAgreementSettings();
        await this.GetProductCategoryDateRange();
        await this.getUsersPermission();
        this.stopBlockUI();

    }
    ngAfterViewInit() {
        //this.btnCreditCheckNext.focus();
    }

    // ngOnDestroy(){
    //     Helpers.LogInfo("in ng destroy","ng");
    // }

    ngOnInit() {
        //  this.events.publish("event:blockUnblockLoctionChange");
        if (typeof this.router.getCurrentNavigation == "function")
            this.currentNavigation = this.router.getCurrentNavigation();

        Helpers.LogInfo("in ng on it ", "ng");
        this.route.params.subscribe(params => {
            if (params['from'] === 'quote' && params['id']) {
                this.isFromQuote = true;
                localStorage.setItem('BlockLocation', 'true');
                this.isQuoteUpdate = true;
                this.isQuoteConvert = false;
                this.SetQuoteData(this.dataProvider.storage);
                this.QuoteItemLocation = this.dataProvider.storage;

            }
            else if (params['from'] === 'quote') {
                this.isFromQuote = true;
                localStorage.setItem('BlockLocation', 'true');
                this.isQuoteConvert = true;
                this.isQuoteUpdate = false;
                this.SetQuoteData(this.dataProvider.storage);
                this.QuoteItemLocation = this.dataProvider.storage;

            } else if (params['from'] === 'historycopy') {
                localStorage.setItem('BlockLocation', 'true');
                this.SetHistoryCopyData(this.dataProvider.storage, params['type']);

            } else {
                this.blockUI.stop();
            }


            // if (this.router.getCurrentNavigation().trigger === "popstate") {
            if (this.currentNavigation != null && this.currentNavigation.trigger === "popstate") {
                if (Object.keys(params).length != 0) {
                    this.initialise();
                    this.dontCallNgOnInit = true;
                } else {
                    this.router.navigate['/bookingcomplete']
                }
            }


        });
        if (!this.dontCallNgOnInit) {
            this.initialise();
        }
    }

    async getDefaultBankCode(locationCode: string): Promise<void> {
        try {
            const bank = await this.bookingService.GetDefaultBankCode(locationCode);
            this.defaultBankCode = bank.SetupValue;
        } catch (error) {
            if (locationCode) {
                await this.getDefaultBankCode(''); // recursively call with empty string if locationCode exists
            }
            Helpers.LogError(error, 'Bank Code');
            // console.log("Bank Code", error);
        }
    }

    SetQuoteData(data: any) {
        this.bookingRequest.bookingNumber = data && data.quote ? data.quote.BookingNumber : '';
        if (data && data.quote && data.quote.items && data.quote.items.length > 0) {
            this.blockUI.start();
            this.remarks = data.quote.Remarks;
            this.isAlert = data.quote.IsAlert;
            this.bookingId = data.quote.BookingId;
            //if (this.isQuoteUpdate) {
            this.blockUI.start();
            this.itemServiceProvider.getSignatureById(this.bookingId).then((signature) => {
                if (signature.length === 0) {
                    this.signature = undefined;
                } else {
                    this.signature = "data:image/png;base64," + signature;
                    // this.bookingRequest.bookingBook.signatureImage =this.signature;
                }
                // this.blockUI.stop();
            });
            //}
            this.blockUI.start();
            let customerRequest = new CustomerRequest();
            customerRequest.name = data.quote.CustomerId;
            this.customerServiceProvider.GetCustomer(customerRequest, (response) => {
                if (response.errorMessage) {
                    this.alertService.error(response.errorMessage);
                    this.blockUI.stop();
                    return;
                }
                if (response.length == 1) {
                    this.receiveSelectedCustomer({ customerDetails: response[0] }).then(() => {
                        this.isItemSearchDisable = false;
                        this.nextStep();
                        let itemRequest = new ItemRequest();
                        itemRequest.id = data.quote.items.filter(i => i.checked === true).map(i => i.ProductId).join(',');
                        this.itemServiceProvider.getItemsByIds(itemRequest, (response: any) => {
                            if (response.length == 0) {
                                this.alertService.warning('Quote item details not found');
                                this.blockUI.stop();
                            } else {
                                this.isQuoteBooking = true;
                                data.quote.items.forEach(qi => {
                                    if (qi.checked === true) {
                                        let item = response.find(i => i.itemId === qi.ProductId);
                                        if (item) {
                                            let clone = JSON.parse(JSON.stringify(item));
                                            clone.itemBalance.OnHandQuantity = qi.Quantity;
                                            clone.price = qi.Price;
                                            clone.amount = Number((clone.price * clone.itemBalance.OnHandQuantity));
                                            if (new Date(qi.StartDate) < new Date()) {
                                                qi = this.setDefaultDatesForItems(qi);
                                            } else {
                                                clone.startDate = new Date(qi.StartDate);
                                                clone.endDate = new Date(qi.EndDate);
                                            }

                                            clone.IsPriceOveridden = qi.IsPriceOveridden;
                                            clone.BookingItemId = qi.BookingItemId;
                                            console.log("Start date:" + qi.StartDate);
                                            clone.isAllowedEdit = this.isQuoteUpdate == true ? true : this.AllowedEdit;
                                            this.selectedItem = clone;
                                            this.addItem(true, true);
                                        }
                                    }
                                });
                                this.blockUI.stop();
                                if (data.type === 'quote') this.setStep(6);
                                else if (data.type === 'prepay') this.prepay()
                                else this.book();
                            }
                        }, (error) => {
                            Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                            this.blockUI.stop();
                            if (error.Code == 401)
                                this.alertService.error('Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.')
                            else if (error.Message)
                                this.alertService.error(error.Message)
                        });
                    });
                } else {
                    this.alertService.warning('Quote customer detail not found.', false, true);
                    this.blockUI.stop();
                }
            }, (error) => {
                Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                this.blockUI.stop();
                if (error.Code == 401)
                    this.alertService.error('Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.')
                else if (error.Message)
                    this.alertService.error(error.Message)
            });
        }
        else {
            this.isQuoteUpdate = false;
            this.router.navigate(['booking/']);
        }
    }

    SetHistoryCopyData(data: any, type: string) {
        const copyData = data ? JSON.parse(JSON.stringify(data)) : null;
        this.dataProvider.storage = undefined;

        if (!(copyData && copyData.items && copyData.items.length > 0)) {
            this.alertService.warning('History order details not found.', false, true);
            this.finishHistoryCopyBootstrap();
            return;
        }

        const customerId = this.getHistoryCopyCustomerId(copyData);
        if (!customerId) {
            this.alertService.error('Unable to copy this record because the customer could not be identified.');
            this.finishHistoryCopyBootstrap();
            return;
        }

        this.bookingRequest.bookingNumber = '';
        this.bookingId = undefined;
        this.remarks = copyData.history?.Remarks || '';
        this.isAlert = !!copyData.history?.IsAlert;
        this.setDefaultDates();
        this.isBookEnabled = false;
        this.isPrepayEnabled = false;
        this.isQuoteEnabled = false;
        this.showItemDetails = false;

        this.blockUI.start();
        const customerRequest = new CustomerRequest();
        customerRequest.name = customerId;

        this.customerServiceProvider.GetCustomer(customerRequest, (response) => {
            if (response.length === 1) {
                this.receiveSelectedCustomer({ customerDetails: response[0] }).then(() => {
                    this.isItemSearchDisable = false;

                    const itemRequest = new ItemRequest();
                    itemRequest.id = copyData.items
                        .map(item => this.getHistoryCopyItemId(item))
                        .filter(itemId => !!itemId)
                        .join(',');

                    if (!itemRequest.id) {
                        this.alertService.warning('Unable to copy this record because no item details were found.', false, true);
                        this.finishHistoryCopyBootstrap();
                        return;
                    }

                    this.itemServiceProvider.getItemsByIds(itemRequest, (itemsResponse: any) => {
                        if (!itemsResponse || itemsResponse.length === 0) {
                            this.alertService.warning('History item details not found.', false, true);
                            this.finishHistoryCopyBootstrap();
                            return;
                        }

                        const copiedItems: ItemDetails[] = [];
                        copyData.items.forEach(historyItem => {
                            const productId = this.getHistoryCopyItemId(historyItem);
                            const item = itemsResponse.find(i => i.itemId === productId);
                            if (!item) {
                                return;
                            }

                            const clone = JSON.parse(JSON.stringify(item));
                            const quantity = this.getHistoryCopyItemQuantity(historyItem);
                            clone.itemBalance.OnHandQuantity = quantity;
                            clone.quantity = quantity;
                            clone.price = this.getHistoryCopyItemPrice(historyItem, clone.price);
                            clone.amount = Number(clone.price * quantity);
                            clone.itemBalance.Location = historyItem.Location || clone.itemBalance.Location || Utils.getLocation();
                            clone.IsPriceOveridden = !!historyItem.IsPriceOveridden;
                            clone.BookingItemId = undefined;
                            clone.isAllowedEdit = true;
                            copiedItems.push(this.prepareHistoryCopyBookingItem(this.setDefaultDatesForItems(clone)));
                        });

                        this.addedItems = copiedItems;
                        this.selectedItem = null;
                        this.itemsDetails = null;
                        this.isSummaryDisable = this.addedItems.length === 0;
                        this.updateBookingAmount();
                        this.openCopiedSalesPanel((type || copyData.type) === 'prepay' ? 'prepay' : 'book');
                        this.alertService.warning('Copied item dates were reset. Review ship dates before submitting.', false, true);
                    }, (error) => {
                        Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                        this.finishHistoryCopyBootstrap();
                        if (error.Code == 401)
                            this.alertService.error('Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.');
                        else if (error.Message)
                            this.alertService.error(error.Message);
                    });
                }).catch(() => {
                    this.finishHistoryCopyBootstrap();
                });
            } else {
                this.alertService.warning('History customer detail not found.', false, true);
                this.finishHistoryCopyBootstrap();
            }
        }, (error) => {
            Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
            this.finishHistoryCopyBootstrap();
            if (error.Code == 401)
                this.alertService.error('Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.');
            else if (error.Message)
                this.alertService.error(error.Message);
        });
    }

    private getHistoryCopyCustomerId(data: any): string {
        return data?.history?.CustomerId
            || data?.history?.CustomerID
            || data?.history?.NameId
            || data?.history?.ClientId
            || '';
    }

    private getHistoryCopyItemId(item: any): string {
        return item?.ProductId || item?.itemId || item?.Id || item?.id || '';
    }

    private getHistoryCopyItemQuantity(item: any): number {
        const quantity = Number(item?.Quantity ?? item?.quantity ?? item?.Qty ?? 0);
        return isNaN(quantity) ? 0 : quantity;
    }

    private getHistoryCopyItemPrice(item: any, fallbackPrice: number = 0): number {
        const price = Number(item?.Price ?? item?.price ?? fallbackPrice ?? 0);
        return isNaN(price) ? 0 : price;
    }

    private prepareHistoryCopyBookingItem(item: ItemDetails): ItemDetails {
        item.itemBalance.OnHandQuantity = parseFloat(item.itemBalance.OnHandQuantity.toString());
        item.quantity = parseFloat(item.itemBalance.OnHandQuantity.toString());
        item.price = parseFloat(item.price.toString());
        item.amount = Number(item.price * item.quantity);
        item.location = item.itemBalance.Location;
        (item as any).isCopiedPriceLocked = true;
        return item;
    }

    private openCopiedSalesPanel(type: 'book' | 'prepay') {
        this.step = 5;
        this.blockUI.start();
        this.requestHelper.refreshAgrisLicenseCounter().then(() => {
            if (type === 'prepay') {
                this.isPrepayEnabled = true;
                this.isBookEnabled = false;
                this.bookingRequest.bookingPrepay.chequeAmount = this.bookingRequest.totalBookingAmount;
                this.setStep(7);
            } else {
                this.isBookEnabled = true;
                this.isPrepayEnabled = false;
                this.setStep(6);
            }
            this.finishHistoryCopyBootstrap();
        }).catch((err) => {
            Helpers.LogError(err);
            this.finishHistoryCopyBootstrap();
        });
    }

    private stopBlockUI(force: boolean = false) {
        if (force || !this.isHistoryCopyBootstrapInProgress) {
            this.blockUI.stop();
        }
    }

    private finishHistoryCopyBootstrap() {
        this.isHistoryCopyBootstrapInProgress = false;
        this.blockUI.stop();
    }

    setStep(index: number) {
        this.step = index;
        this.alertService.clear();
        // if (this.step === 2 || this.step === 5 || this.step === 6) {
        //     this.moveSearchButton();
        // }
    }
    updatePrepayCheckAmount() {
        if (this.bookingRequest.bookingPrepay) {
            var prepayChequeNumber = this.bookingRequest.totalBookingAmount.toFixed(2);
            this.bookingRequest.bookingPrepay.chequeAmount = prepayChequeNumber;
        }
    }

    nextStep() {
        this.step++;
    }

    prevStep() {
        this.step--;
    }

    validateItemFromQuoteToBookORPrepay(): Promise<any> {
        var response: any = {
            overrideWithoutWarning: false,
            overrideWithWarning: false,
            overrideRestricted: false,
            itemsWithGreaterMax: [],
            itemsWithLessMin: [],
            messageForitemsWithGreaterMax: "",
            messageForitemsWithLessMin: "",
            overrideRestrictedMessage: "",
            overrideWithWarningMessage: "",
            overrideMinWithWarningMessage: "Current price is less than minimum price. Override It?",
            overrideMinRestrictedMessage: "Current price is less than minimum price.",
            overrideMaxWithWarningMessage: "Current price is greater than maximum price. Override It?",
            overrideMaxRestrictedMessage: "Current price is greater than maximum price.",
        };
        return new Promise((resolve, reject) => {
            this.itemServiceProvider.IsPriceOverrideAllowed().then((data) => {
                this.addedItems.forEach(item => {
                    item.maximumPrice = item.maximumPrice == 0 ? Number.MAX_VALUE : item.maximumPrice;
                    if (item.price < item.minimumPrice || item.price > item.maximumPrice) {
                        let itemDetails = `<br>${item.name}  (${item.id})  $${item.price}<br>`;
                        if (data.overrideRestricted) {
                            response.overrideRestricted = true;
                            if (item.price < item.minimumPrice) {
                                response.itemsWithLessMin.push(itemDetails);
                                response.overrideMinRestrictedMessage += itemDetails;
                                response.overrideRestrictedMessage += response.overrideMinRestrictedMessage;
                            } else if (item.price > item.maximumPrice) {
                                response.itemsWithGreaterMax.push(itemDetails);
                                response.overrideMaxRestrictedMessage += itemDetails;
                                response.overrideRestrictedMessage += response.overrideMaxRestrictedMessage;
                            }
                        }
                        else if (data.overrideWithWarning) {
                            response.overrideWithWarning = true;
                            if (item.price < item.minimumPrice) {
                                response.itemsWithLessMin.push(itemDetails);
                                response.overrideMinWithWarningMessage += itemDetails;
                                response.overrideWithWarningMessage += response.overrideMinWithWarningMessage;
                            } else if (item.price > item.maximumPrice) {
                                response.itemsWithGreaterMax.push(itemDetails);
                                response.overrideMaxWithWarningMessage += itemDetails;
                                response.overrideWithWarningMessage += response.overrideMaxWithWarningMessage;
                            }
                        }
                        else {
                            response.overrideWithoutWarning = true;
                        }
                    }
                    else {
                        response.overrideWithoutWarning = true;
                    }
                });
                if (response.itemsWithGreaterMax.length > 0) {
                    response.messageForitemsWithGreaterMax = data.overrideRestricted ? "Current price is greater than maximum price." : data.overrideWithWarning ? "Current price is greater than maximum price. Override It?" : "";
                }
                else if (response.itemsWithLessMin.length > 0) {
                    response.messageForitemsWithLessMin = data.overrideRestricted ? "Current price is less than minimum price." : data.overrideWithWarning ? "Current price is less than minimum price. Override It?" : "";
                }

                resolve(response);

            }).catch(e => {
                reject(e);
            });

        });
    }
    addItem(isNewItem: boolean, fromQuote: boolean) {

        if (fromQuote) {
            //this.setBeginingAndEndDateForItem(this.selectedItem);
            this.addItemComplete(isNewItem);
            return;
        }

        if (!this.validateItemDate(this.selectedItem)) return;
        this.blockUI.start();
        var response: any = {
            overrideMinWithWarningMessage: "Current price is less than minimum price. Override It?",
            overrideMinRestrictedMessage: "Current price is less than minimum price.",
            overrideMaxWithWarningMessage: "Current price is greater than maximum price. Override It?",
            overrideMaxRestrictedMessage: "Current price is greater than maximum price."
        };
        this.itemServiceProvider.IsPriceOverrideAllowed().then((data) => {
            this.selectedItem.maximumPrice = this.selectedItem.maximumPrice == 0 ? Number.MAX_VALUE : this.selectedItem.maximumPrice;
            if ((this.selectedItem.price < this.selectedItem.minimumPrice || this.selectedItem.price > this.selectedItem.maximumPrice)) {
                let errorMessage = "";
                if (data.overrideRestricted) {
                    if (this.selectedItem.price < this.selectedItem.minimumPrice) {
                        errorMessage = response.overrideMinRestrictedMessage;
                    } else if (this.selectedItem.price > this.selectedItem.maximumPrice) {
                        errorMessage = response.overrideMaxRestrictedMessage;
                    }
                }
                else if (data.overrideWithWarning) {
                    if (this.selectedItem.price < this.selectedItem.minimumPrice) {
                        errorMessage = response.overrideMinWithWarningMessage;
                    } else if (this.selectedItem.price > this.selectedItem.maximumPrice) {
                        errorMessage = response.overrideMaxWithWarningMessage;
                    }
                }
                if (!this.selectedItem.IsPriceOveridden && data.overrideRestricted) {
                    if (errorMessage)
                        this.alertService.error(errorMessage);
                    var index = this.addedItems.indexOf(this.selectedItem, 0);
                    if (index > -1) {
                        this.addedItems.splice(index, 1);
                        this.updateBookingAmount();
                    }
                    return;
                }
                else if (!this.selectedItem.IsPriceOveridden && data.overrideWithWarning) {
                    utils.confirmationDialog('Confirmation', errorMessage, 'Confirm', (result) => {
                        if (result == 'Confirm') {
                            this.addItemComplete(isNewItem);

                        }
                        else {
                            var index = this.addedItems.indexOf(this.selectedItem, 0);
                            if (index > -1) {
                                this.addedItems.splice(index, 1);
                                this.updateBookingAmount();
                            }
                        }
                    });
                }
                else {
                    this.addItemComplete(isNewItem);
                }
            }
            else {
                this.addItemComplete(isNewItem);
            }

        }).catch(e => {
            Sentry.captureMessage("Handled Error: " + JSON.stringify(e));
            // this.alertService.error(e);
        }).finally(() => {
            this.blockUI.stop();
        })
        //this.alertService.success("Record saved successfully.", false, true);
    }

    addItemComplete(isNewItem) {
        var index = this.addedItems.indexOf(this.selectedItem, 0);
        if (index > -1) {
            this.addedItems.splice(index, 1);
            this.updateBookingAmount();
        }

        this.isSummaryDisable = false;
        // this.selectedItem.priceLevel1 = this.selectedItem.priceLevel1 ? parseFloat(this.selectedItem.priceLevel1.toString()) : undefined;
        this.selectedItem.itemBalance.OnHandQuantity = parseFloat(this.selectedItem.itemBalance.OnHandQuantity.toString());
        this.selectedItem.quantity = parseFloat(this.selectedItem.itemBalance.OnHandQuantity.toString());
        this.selectedItem.price = parseFloat(this.selectedItem.price.toString());
        this.selectedItem.location = this.selectedItem.itemBalance.Location;
        this.addedItems.push(this.selectedItem);

        if (this.addedItems.length > 0) {
            var LocationChangeAllow = (localStorage.getItem("BlockLocation")) ? localStorage.getItem("BlockLocation") === 'true' ? true : false : false;
            if (!LocationChangeAllow) {
                localStorage.setItem("BlockLocation", 'true');
            }

        }

        if (!isNewItem) {
            this.setStep(5);

        }
        else {
            this.setStep(3);
        }
        this.showItemDetails = false;
        this.resetItemSearch();
        this.updateBookingAmount();


    }
    splitSales(isLocation): Promise<any> {
        if (isLocation)
            return this.splitSalesByLocation();
        return new Promise((resolve, reject) => {
            const promisesCat = [];
            const promisesFert = [];
            const customerPromise = [];
            this.bookingRequests = [];
            this.addedItems.forEach((item) => {
                promisesCat.push(this.itemSerivce.GetProductCategory(item.productCategory).then((cat) => {
                    cat = cat[0];
                    if (cat.CategoryType == "1") // for Fertilizer
                    {
                        promisesFert.push(this.itemSerivce.GetFertilizerItem(item.itemId).then((Fitem) => {
                            Fitem = Fitem[0];
                            if (Fitem && Fitem.IsLime == 0) {
                                item.categoryType = CategoryType[1];
                            } else {
                                item.categoryType = CategoryType[7]
                            }
                        }).catch((err) => {
                            item.categoryType = CategoryType[1];
                        }));

                    } else {
                        item.categoryType = CategoryType[cat.CategoryType];
                    }
                }));
            })
            Promise.all(promisesCat).then(() => {
                Promise.all(promisesFert).then(() => {
                    this.splits.forEach((split: any) => {
                        let splitBookingRequest = JSON.parse(JSON.stringify(this.bookingRequest));
                        splitBookingRequest.bookingItems = JSON.parse(JSON.stringify(this.addedItems));
                        let cRequest = new CustomerRequest();
                        cRequest.nameId = split.SplitClientId;


                        splitBookingRequest.bookingItems.forEach((item) => {
                            switch (item.categoryType) {
                                case "Fertilizer": {
                                    item.quantity = item.quantity * parseFloat(split.FertilizerPercent) / 100;
                                    item.percentage = split.FertilizerPercent;
                                    break;
                                }
                                case "Chemical": {
                                    item.quantity = item.quantity * parseFloat(split.ChemicalPercent) / 100;
                                    item.percentage = split.ChemicalPercent;
                                    break;
                                }
                                case "Seed": {
                                    item.quantity = item.quantity * parseFloat(split.SeedPercent) / 100;
                                    item.percentage = split.SeedPercent;
                                    break;
                                }
                                case "Service": {
                                    item.quantity = item.quantity * parseFloat(split.ServicePercent) / 100;
                                    item.percentage = split.ServicePercent;
                                    break;
                                }
                                case "Lime": {
                                    item.quantity = item.quantity * parseFloat(split.LimePercent) / 100;
                                    item.percentage = split.LimePercent;
                                    break;
                                }
                                default: {
                                    item.quantity = split.SplitClientId == this.selectedCustomer.nameId ? item.quantity : 0;
                                    item.percentage = split.SplitClientId == this.selectedCustomer.nameId ? 100 : 0;
                                    return;
                                }
                            }
                            item.amount = item.price * item.quantity;
                        });
                        splitBookingRequest.bookingItems = splitBookingRequest.bookingItems.filter(x => x.quantity > 0);
                        splitBookingRequest.dataSource = new MatTableDataSource(splitBookingRequest.bookingItems);
                        if (split.SplitClientId != this.selectedCustomer.nameId) {
                            customerPromise.push(this.customerServiceProvider.GetCustomersLiveFromNameAddress(cRequest, this.pendingAgreementConfig.emailType).then((customerInfo) => {
                                splitBookingRequest.customerInfo = customerInfo[0];

                            }).catch((error) => {
                                Sentry.captureMessage("Handled Error GetCustomersLiveFromNameAddress: " + JSON.stringify(error));
                            }));

                            customerPromise.push(this.customerServiceProvider.GetCustomerCreditDetails(cRequest.nameId).then((creditInfo) => {
                                splitBookingRequest.creditInfo = creditInfo;
                                this.bookingRequests.push(splitBookingRequest);
                            }).catch((error) => {
                                Sentry.captureMessage("Handled Error GetCustomerCreditDetails: " + JSON.stringify(error));
                            }));
                        } else {
                            this.bookingRequests.push(splitBookingRequest);
                            // customerPromise.push(this.pushBooking(splitBookingRequest));
                        }
                    });
                    Promise.all(customerPromise).then(() => {
                        resolve(true);
                    });

                });
            });
        });
    }
    splitSalesByLocation(): Promise<any> {
        return new Promise((resolve, reject) => {
            const customerPromise = [];
            this.bookingRequests = [];
            const groupedItems = utils.groupBy(this.addedItems, 'branch');
            Object.entries(groupedItems).forEach((split: any) => {
                let splitBookingRequest = JSON.parse(JSON.stringify(this.bookingRequest));
                splitBookingRequest.bookingItems = JSON.parse(JSON.stringify(split[1]));
                splitBookingRequest.location = splitBookingRequest.bookingItems[0].branch;
                this.bookingRequests.push(splitBookingRequest);
            });
            Promise.all(customerPromise).then(() => {
                resolve(true);
            });
        });
    }
    pushBooking(splitBookingRequest): Promise<any> {
        return new Promise((r) => {
            this.bookingRequests.push(splitBookingRequest);
        });
    }
    setBeginingAndEndDateForItem(item: ItemDetails) {
        if (this.productCategoryDateRange) {
            let itemConfig = this.productCategoryDateRange.find(i => i.Name == item.productCategory)
            if (itemConfig) {
                let value = JSON.parse(itemConfig.Value);
                if (value) {
                    var endDateYear = new Date(Date.now()).getFullYear();
                    var endDateMonth = new Date(Date.now()).getMonth();
                    var endDateDate = new Date(Date.now()).getDate();
                    var currentDate = new Date(endDateYear, endDateMonth, endDateDate);
                    item.startDate = item.startDate;
                    let configStartDate = new Date(value.BeginingDate);
                    let configEndDate = new Date(value.EndingDate);
                    if (configStartDate > currentDate) {
                        item.startDate = configStartDate; //value.BeginingDate ? value.BeginingDate : item.startDate;
                    }
                    item.endDate = item.endDate;
                    if (configEndDate > item.startDate) {
                        item.endDate = configEndDate;//value.EndingDate ? value.EndingDate : item.endDate;
                    }
                }
            }
        }

    }
    showSplitDetails() {
        this.blockUI.start();
        // this.splitSales().then(()=>{
        this.blockUI.stop();
        const dialogRef3 = this.dialog.open(CustomerSplitDetailsComponent, {
            width: window.innerWidth + 'px',
            maxHeight: window.innerHeight - 100 + 'px',
            data: { bookingRequests: this.bookingRequests }
        });

        dialogRef3.afterClosed().subscribe(result => {

        });
        this.closeDialogService.emitRegisterDialog(dialogRef3);
        // });
    }
    recalculateAddedItem() {
        this.addedItems.forEach((item) => {
            if (!(item as any).isCopiedPriceLocked) {
                if (this.customerPriceLevel == '2')
                    item.price = item.priceLevel2;
                else
                    item.price = item.priceLevel1;
            }
            item.amount = Number((item.price * item.itemBalance.OnHandQuantity));
        });
        this.updateBookingAmount();
    }
    checkInput($event) {
        let value = $event.target.value;
        let e = <KeyboardEvent>$event;
        let input = $event.target.name;

        // Determine the precision based on the input type
        let decimalLimit;
        if (input == "price") {
            decimalLimit = this.unitPricePrecision;
        } else if (input == "quantity") {
            decimalLimit = this.productQuantityPrecision;
        }

        // Allow negative sign only at the start of the value
        if (value.includes('-') && value.indexOf('-') > 0) {
            value = value.replace('-', ''); // Remove misplaced '-'
        }

        // Handle decimal precision
        let decimalPosition = this.countDecimals(value);
        if (decimalPosition > decimalLimit) {
            value = value.substring(0, value.length - (decimalPosition - decimalLimit));
            $event.target.value = value;
        }

        // Update the corresponding field
        if (input == "price") {
            this.selectedItem.price = value;
        }
        if (input == "quantity") {
            this.selectedItem.itemBalance.OnHandQuantity = value;
        }

        // Prevent invalid input
        const isValid = /^-?\d*(\.\d*)?$/.test(value); // Regex to allow numbers with an optional negative sign and decimal
        if (!isValid) {
            $event.target.value = this.selectedItem[input] || ''; // Revert to last valid value
            e.preventDefault();
        }
    }
    countDecimals(value: any) {
        if (Math.floor(value) === value) return 0;
        if (value.indexOf(".") > -1) {
            return value.toString().split(".")[1].length;
        } else {
            return 0;
        }
    }
    CalculateAmount() {

        if (isNaN(this.selectedItem.price) || isNaN(this.selectedItem.itemBalance.OnHandQuantity)) {
            this.selectedItem.amount = 0;
            return;
        }

        this.selectedItem.amount = Number((this.selectedItem.price * this.selectedItem.itemBalance.OnHandQuantity));
        if (this.selectedItem.itemBalance.OnHandQuantity > Number(this.selectedItem.itemBalance.OnHandQuantity)) {
            this.alertService.warning("No Inventory on hand", false, true);
        }

    }
    editItem(item: ItemDetails) {
        this.itemSelection(item, true);
    }
    deleteItem(item) {
        utils.confirmationDialog('Confirmation', 'Are you sure you want to delete this item?', 'Confirm', (result) => {
            if (result == 'Confirm') {
                var index = this.addedItems.indexOf(item, 0);
                if (index > -1) {
                    this.addedItems.splice(index, 1);
                }

                if (this.addedItems.length == 0) {
                    localStorage.removeItem('BlockLocation');
                    if (this.isFromQuote) {
                        this.isQuoteUpdate = true;
                        this.isQuoteConvert = false;

                    } else {
                        this.events.publish("event:blockUnblockLoctionChange");
                    }

                }

                this.alertService.success('Item deleted successfully.', false, true);
                this.updateBookingAmount();
                this.step = 7;

                if (this.totalItemsCount == 0) {
                    this.isBookEnabled = false;
                    this.isPrepayEnabled = false;
                    this.isQuoteEnabled = false;
                }
            }
        });
    }
    resetItemSearch() {
        this.selectedItem = new ItemDetails();
    }
    updateBookingAmount() {
        this.bookingRequest.totalBookingAmount = this.CalculateTotalBookingAmount();
        this.totalItemsCount = this.addedItems.length;
        this.displayItemsTable();
    }
    CalculateTotalBookingAmount() {
        var amt = 0;
        for (var i = 0; i < this.addedItems.length; i++) {
            amt = amt + this.addedItems[i].amount;
        }
        return Number(amt);
    }
    PostBooking($event) {
        this.events.publish("event:blockUnblockLoctionChange");
        if (this.validateBooking($event) === false)
            return;

        this.PostBookingComplete($event);

        // if(this.isQuoteBooking && !this.isQuoteUpdate)
        // {
        // this.blockUI.start();
        // this.validateItemFromQuoteToBookORPrepay().then((data) => {
        //     if(data.overrideRestricted){                                  
        //         // this.alertService.error(data.overrideRestrictedMessage); 
        //         utils.confirmationDialogWithWidth('Error', data.overrideRestrictedMessage, "Ok", null, false, "500px", null);                  
        //         return;
        //         }
        //         else if(data.overrideWithWarning){
        //             utils.confirmationDialogWithWidth('Confirmation', data.overrideWithWarningMessage, 'Confirm', "Close", true, "500px", (result) => {
        //                 if (result == 'Confirm') {
        //                     this.PostBookingComplete($event);
        //                 }
        //                 else
        //                 {
        //                     return; 
        //                 }
        //             });
        //         }
        //         else{
        //             this.PostBookingComplete($event);
        //         }

        // })
        // .catch(err => 
        //     {
        //         this.alertService.error(err);
        //     })
        //     .finally(() => {
        //         this.blockUI.stop();
        //     })
        // }
        // else
        // {
        // this.PostBookingComplete($event);
        // }
    }

    validateBooking($event: any): boolean {
        if ($event.mode == GlobalConstants.SalesTransactionModes.Book) {
            if (this.bookingProgramDropdownRequired === GlobalConstants.BookingProgramFieldStatuses.Required
                && this.bookingProgramDropdownStatus == true
                && (!$event.bookingProgram)
            ) {
                this.alertService.error("Booking program is required.", false, true);
                return false;
            }

        }

        return true;
    }

    PostBookingComplete($event) {
        const groupedItems = utils.groupBy(this.addedItems, 'branch');
        this.bookingRequest.location = this.addedItems[0].branch;
        if (Object.entries(groupedItems).length > 1)
            this.SplitPostBookingComplete($event, true)
        else {
            this.bookingRequest.approveBookingRequest.status = null;
            this.blockUI.start();
            if (this.isPostInprogress)
                return;
            this.isPostInprogress = true;
            let transaction = this.startBookingTransaction(`Transaction:(${$event.mode})`);
            this.bookingRequest.pendingAgreementConfig = this.pendingAgreementConfig.pendingAgreementStatus;
            this.bookingRequest.isQuoteConverted = this.isQuoteBooking;
            let btnname: string;


            if ($event.mode == "Book") {
                btnname = this.BookingButtonName;
                let IsSameNumber = localStorage.getItem('isSameBookingNumber') === 'true' ? true : false;
                this.bookingRequest.bookingBook = $event;
                this.bookingRequest.bookingPrepay = null;
                this.bookingRequest.bookingQuote = null;
                this.bookingRequest.isAutoApprove = this.isAutoApproveBooking;
                if (this.bookingId)
                    this.bookingRequest.bookingId = this.bookingId;

                if (this.pendingAgreementConfig.pendingAgreementStatus == true) {
                    this.bookingRequest.approveBookingRequest.status = this.pendingAgreementConfig.pendingBookingStatus;
                }
                if (IsSameNumber) {
                    this.bookingRequest.approveBookingRequest.isSameNumber = IsSameNumber;
                }
                // else
                // {
                //     this.bookingRequest.approveBookingRequest.status = "V";
                // }

            }
            else if ($event.mode == "Quote") {
                btnname = this.QuoteButtonName;
                this.bookingRequest.bookingBook = null;
                this.bookingRequest.bookingPrepay = null;
                let date = new Date();
                this.bookingRequest.expiryDate = new Date(date.setDate(date.getDate() + this.bookingRequest.bookingQuote.expiryDays));
                this.bookingRequest.bookingQuote = $event;
                this.bookingRequest.isAlert = this.bookingRequest.bookingQuote.isAlert;
                if (this.isQuoteUpdate)
                    this.bookingRequest.bookingId = this.bookingId;
                this.bookingRequest.approveBookingRequest.status = this.pendingAgreementConfig.pendingQuoteStatus;
            }
            else if ($event.mode == "Prepay") {
                btnname = this.PrepayButtonName;

                this.bookingRequest.bookingBook = null;
                this.bookingRequest.bookingQuote = null;
                this.bookingRequest.bookingPrepay = $event;
                this.bookingRequest.bankCode = this.defaultBankCode;
                this.bookingRequest.isAutoApprove = this.isAutoPostPrepay;
                if (this.bookingId)
                    this.bookingRequest.bookingId = this.bookingId;
                if (!this.validateDates()) {
                    this.alertService.error("Invalid Check date", false, true);
                    this.isPostInprogress = false;
                    return;
                }

                if (this.pendingAgreementConfig.pendingAgreementStatus == true) {
                    this.bookingRequest.approveBookingRequest.status = this.pendingAgreementConfig.pendingPrepayStatus;
                    if (this.bookingRequest.bookingPrepay && !this.bookingRequest.bookingPrepay.prepayRemarks)
                        this.bookingRequest.bookingPrepay.prepayRemarks = this.pendingAgreementConfig.pendingPrepayStatusDescription;
                }
                // else if(this.isQuoteBooking)
                // {
                //     this.bookingRequest.approveBookingRequest.status = "V";
                // }
            }

            //ASR-709: applly remarks configuration for Booking Program and Farm & Field
            this.bookingRequest.remarksNumberForBookingProgram = 5;
            if (this.pendingAgreementConfig.RemarkNumberForBookingProgram)
                this.bookingRequest.remarksNumberForBookingProgram = +this.pendingAgreementConfig.RemarkNumberForBookingProgram;

            this.bookingRequest.remarksNumberForFarmAndField = 4;
            if (this.pendingAgreementConfig.RemarkNumberForFarmAndField)
                this.bookingRequest.remarksNumberForFarmAndField = +this.pendingAgreementConfig.RemarkNumberForFarmAndField;




            this.bookingRequest.isByPhone = $event.isByPhone;
            var creditInfo = this.credit;
            creditInfo.available = Number(this.selectedCustomer.salesCreditLimit);
            this.bookingRequest.creditInfo = creditInfo;
            this.bookingRequest.nameId = this.selectedCustomer.nameId;
            this.bookingRequest.bookingItems = this.addedItems;
            if (this.pendingAgreementConfig.pendingAgreementStatus == true) {
                this.bookingRequest.toEmails = this.selectedCustomer.mailToEmails;
            }

            if (this.bookingRequest.totalBookingAmount == 0) {
                this.alertService.error('Booking with zero amount cannot be posted.');
                this.isPostInprogress = false;
                return false;
            }

            if (!this.validateDates()) {
                this.alertService.error("Invalid dates", false, true);
                this.isPostInprogress = false;
                return;
            }

            this.setDateFormat();

            if (this.quoteBookingId > 0) {
                this.bookingRequest.ApproveRequest = this.quoteBookingId;
            }
            this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
                this.blockUI.stop();
                if (!this.validateCreditLimit()) {
                    let content = 'Booking Amount ('
                        + this.currencyPipe.transform(this.bookingRequest.totalBookingAmount) +
                        ') exceeds Available Credit ('
                        + this.currencyPipe.transform(this.selectedCustomer.salesCreditLimit) +
                        '). Are you sure you want to continue?';

                    utils.confirmationDialog('Warning', content, 'Continue', (result) => {
                        if (result == 'Continue') {
                            this.blockUI.start();
                            this.gatewayService.postBooking(this.bookingRequest).then((data) => {
                                this.onPostBookingResponse(data, $event.mode, btnname, transaction, this.bookingRequest.approveBookingRequest.status, this.bookingRequest.isAutoApprove);
                            }).catch((error) => {
                                this.onPostBookingResponse(error, $event.mode, btnname, transaction, this.bookingRequest.approveBookingRequest.status, this.bookingRequest.isAutoApprove);
                            }).finally(() => {
                                // this.blockUI.stop();
                            });
                            // this.globals.signalR.PostBooking(this.bookingRequest);
                            // this.globals.signalR.OnResponse('ReturnedPostBookingItemsResult', this.onPostBookingResponse.bind(this, this.bookingRequest));
                        }
                        else {
                            this.isPostInprogress = false;
                        }
                    });
                }
                else {
                    this.blockUI.start();

                    this.gatewayService.postBooking(this.bookingRequest).then((data) => {
                        this.onPostBookingResponse(data, $event.mode, btnname, transaction, this.bookingRequest.approveBookingRequest.status, this.bookingRequest.isAutoApprove);

                    }).catch((error) => {
                        this.onPostBookingResponse(error, $event.mode, btnname, transaction, this.bookingRequest.approveBookingRequest.status, this.bookingRequest.isAutoApprove);

                    }).finally(() => {
                        // this.blockUI.stop()
                    });
                    // this.globals.signalR.PostBooking(this.bookingRequest);
                    // this.globals.signalR.OnResponse('ReturnedPostBookingItemsResult', this.onPostBookingResponse.bind(this, this.bookingRequest));
                }
            }).catch((err) => {
                this.isPostInprogress = false;
                // console.log(err);
                Helpers.LogError(err);
                this.blockUI.stop();
            });
        }
    }

    SplitPostBookingComplete($event, isLocation = false) {
        if (this.selectedFarmAndField != "Not Selected." || isLocation) {
            this.blockUI.start();
            this.splitSales(isLocation).finally(() => {
                this.bookingRequests = this.bookingRequests.filter(x => x.bookingItems.length > 0);
                this.blockUI.stop();

                let btnname: string;
                let transaction = this.startBookingTransaction(`Transaction:(${$event.mode})`);
                this.bookingRequests.forEach((bookingRequest) => {
                    bookingRequest.approveBookingRequest.status = null;
                    this.blockUI.start();
                    // if (this.isPostInprogress)
                    //     return;
                    // this.isPostInprogress = true;
                    bookingRequest.pendingAgreementConfig = this.pendingAgreementConfig.pendingAgreementStatus;
                    bookingRequest.isQuoteConverted = this.isQuoteBooking;


                    if ($event.mode == "Book") {
                        btnname = this.BookingButtonName;
                        let IsSameNumber = localStorage.getItem('isSameBookingNumber') === 'true' ? true : false;
                        bookingRequest.bookingBook = JSON.parse(JSON.stringify($event));
                        bookingRequest.bookingPrepay = null;
                        bookingRequest.bookingQuote = null;
                        bookingRequest.isAutoApprove = this.isAutoApproveBooking ? true : false;
                        if (this.bookingId)
                            bookingRequest.bookingId = this.bookingId;

                        if (this.pendingAgreementConfig.pendingAgreementStatus == true) {
                            bookingRequest.approveBookingRequest.status = this.pendingAgreementConfig.pendingBookingStatus;
                        }
                        if (IsSameNumber) {
                            bookingRequest.approveBookingRequest.isSameNumber = IsSameNumber;
                        }
                    }
                    else if ($event.mode == "Quote") {
                        btnname = this.QuoteButtonName;
                        bookingRequest.bookingBook = null;
                        bookingRequest.bookingPrepay = null;
                        let date = new Date();
                        bookingRequest.expiryDate = new Date(date.setDate(date.getDate() + bookingRequest.bookingQuote.expiryDays));
                        bookingRequest.bookingQuote = JSON.parse(JSON.stringify($event));
                        bookingRequest.isAlert = bookingRequest.bookingQuote.isAlert;
                        if (this.isQuoteUpdate)
                            bookingRequest.bookingId = this.bookingId;
                        bookingRequest.approveBookingRequest.status = this.pendingAgreementConfig.pendingQuoteStatus;
                    }
                    else if ($event.mode == "Prepay") {
                        btnname = this.PrepayButtonName;

                        bookingRequest.bookingBook = null;
                        bookingRequest.bookingQuote = null;
                        bookingRequest.bookingPrepay = JSON.parse(JSON.stringify($event));
                        bookingRequest.bankCode = this.defaultBankCode;
                        bookingRequest.isAutoApprove = this.isAutoPostPrepay ? true : false;
                        if (this.bookingId)
                            bookingRequest.bookingId = this.bookingId;
                        if (!this.validateDates()) {
                            this.alertService.error("Invalid Check date", false, true);
                            this.isPostInprogress = false;
                            return;
                        }

                        if (this.pendingAgreementConfig.pendingAgreementStatus == true) {
                            bookingRequest.approveBookingRequest.status = this.pendingAgreementConfig.pendingPrepayStatus;
                            if (bookingRequest.bookingPrepay && !bookingRequest.bookingPrepay.prepayRemarks)
                                bookingRequest.bookingPrepay.prepayRemarks = this.pendingAgreementConfig.pendingPrepayStatusDescription;
                        }
                    }

                    //ASR-709: applly remarks configuration for Booking Program and Farm & Field
                    bookingRequest.remarksNumberForBookingProgram = 5;
                    if (this.pendingAgreementConfig.RemarkNumberForBookingProgram)
                        bookingRequest.remarksNumberForBookingProgram = +this.pendingAgreementConfig.RemarkNumberForBookingProgram;

                    bookingRequest.remarksNumberForFarmAndField = 4;
                    if (this.pendingAgreementConfig.RemarkNumberForFarmAndField)
                        bookingRequest.remarksNumberForFarmAndField = +this.pendingAgreementConfig.RemarkNumberForFarmAndField;



                    bookingRequest.isByPhone = JSON.parse(JSON.stringify($event)).isByPhone;
                    var creditInfo = bookingRequest.creditInfo;
                    creditInfo.available = Number(bookingRequest.customerInfo.salesCreditLimit);
                    bookingRequest.creditInfo = creditInfo;
                    if (this.pendingAgreementConfig.pendingAgreementStatus == true) {
                        bookingRequest.toEmails = bookingRequest.customerInfo.mailToEmails;
                    }

                    if (bookingRequest.totalBookingAmount == 0) {
                        this.alertService.error('Booking with zero amount cannot be posted.');
                        this.isPostInprogress = false;
                        return false;
                    }

                    if (!this.validateDates()) {
                        this.alertService.error("Invalid dates", false, true);
                        this.isPostInprogress = false;
                        return;
                    }

                    this.setDateFormat();

                    if (this.quoteBookingId > 0) {
                        bookingRequest.ApproveRequest = this.quoteBookingId;
                    }
                });

                this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
                    this.blockUI.start();
                    let r = this.stringify(this.bookingRequests);
                    let request = JSON.parse(r);
                    this.gatewayService.postsplitBooking(request, isLocation).then((response) => {
                        response.forEach((data: any) => {
                            let customerDetails: any = this.bookingRequests.find(x => x.customerInfo.nameId == data.TransactionObject.CustomerId) || {};

                            customerDetails = customerDetails.customerInfo ? customerDetails.customerInfo : null;

                            // this.bookingRequests.filter(x => x.customerInfo.nameId == data.TransactionObject.CustomerId)[0].customerInfo;
                            this.onPostBookingResponse(data, $event.mode, btnname, transaction, this.bookingRequests[0].approveBookingRequest.status, this.bookingRequests[0].isAutoApprove, true, JSON.stringify(response), customerDetails);
                        });

                    }).catch((error) => {
                        this.onPostBookingResponse(error, $event.mode, btnname, transaction, this.bookingRequests[0].approveBookingRequest.status, this.bookingRequest.isAutoApprove, true);
                    }).finally(() => { this.blockUI.stop() });
                }).catch((err) => {
                    this.isPostInprogress = false;
                    Helpers.LogError(err);
                    this.blockUI.stop();
                });
            });
        }
    }
    stringify(obj) {
        let cache = [];
        let str = JSON.stringify(obj, function (key, value) {
            if (typeof value === "object" && value !== null) {
                if (cache.indexOf(value) !== -1) {
                    // Circular reference found, discard key
                    return;
                }
                // Store value in our collection
                cache.push(value);
            }
            return value;
        });
        cache = null; // reset the cache
        return str;
    }
    onPostBookingResponse(response: any, mode: string, Button: string, transaction: any, status: string, isAutoApprove: boolean, isSplit = false, splits?: any, customerDetails?: any) {
        let IsSameNumber = localStorage.getItem('isSameBookingNumber') === 'true' ? true : false;
        let createdDateTime = response.CreatedDateTime;
        // this.blockUI.stop();
        this.isPostInprogress = false;
        transaction?.finish?.();
        try {
            if (response.ErrorMessage) {
                Sentry.captureMessage("Handled Error: " + JSON.stringify(response));
                if (response.ErrorMessage.toUpperCase().includes('LICENSE'))
                    return this.alertService.error(response.ErrorMessage);
                return this.alertService.error(response.ErrorMessage);
            }
            if (!response.TransactionObject)
                return this.alertService.error("Agris Service error. Posting was not successful.");

            let documentNumber = response.TransactionObject.BookingNumber ? response.TransactionObject.BookingNumber : response.Document;
            if ((this.pendingAgreementConfig.pendingAgreementStatus == true || !this.isQuoteBooking) && (status || response.isAutoApprove)) {
                let bookingId = response.TransactionObject.Data;
                let bookingNumber = (this.isAutoApproveBooking == true || this.isAutoPostPrepay == true) ? bookingId : response.TransactionObject.BookingNumber;


                if (!bookingNumber) {
                    this.blockUI.stop();
                    return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.PostingFailure] }]);
                }
                this.blockUI.start();
                this.printBookingPdf(documentNumber, bookingId, mode, Button, response.TransactionMessage, isAutoApprove, this.pendingAgreementConfig.pendingAgreementStatus, bookingNumber, isSplit, splits, createdDateTime, customerDetails);
            } else {
                let bookingId = response.TransactionObject.Data;
                // let bookingNumber = (this.isAutoApproveBooking == true || this.isAutoPostPrepay == true) ? bookingId : response.TransactionObject.BookingNumber;

                if (this.isQuoteConvert && ((mode == "Book" && this.isAutoApproveBooking && IsSameNumber == false) || (mode == "Prepay" && this.isAutoPostPrepay))) {
                    this.gateway.voidBooking(this.bookingRequest).then((result) => {
                        if (result.TransactionObject) {
                            this.blockUI.stop();
                            return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus }]);
                        } else {
                            this.blockUI.stop();
                            return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.VoidFailure] }]);
                        }
                    }).catch((e) => {
                        this.blockUI.stop();
                        return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.VoidFailure] }]);
                    })
                } else {
                    this.blockUI.stop();
                    return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus }]);
                }
            }
        }
        catch (ex) {
            this.blockUI.stop();
            Sentry.captureMessage("Handled Error: " + JSON.stringify(ex));
            return this.alertService.error("Agris Service error. Posting was not successful.");
        }
    }
    printBookingPdf(documentNumber: any, bookingId: any, mode: any, Button: string, bookingReceiptNumber: any, isAutoApprove: boolean, PendingAgreement: boolean, bookingNumber, isSplit = false, splits: any, createdDateTime: any, customerDetails = null) {
        try {
            console.log("in print pdf");
            let type = "";
            let button = "";
            if (mode == "Prepay") {
                type = "Prepay";
                button = this.PrepayButtonName;
            }
            else if (mode == "Book") {
                type = "Booking";
                button = this.BookingButtonName;
            }
            else if (mode == "Quote") {
                type = "Quote";
                button = this.QuoteButtonName;
            }

            let IsSameNumber = localStorage.getItem('isSameBookingNumber') === 'true' ? true : false;
            let getPdfBit: boolean = isAutoApprove == false;
            let encryptedId = this.cryptoService.encryptString(bookingId.toString());
            // this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
            this.blockUI.start();
            this.gatewayService.printBooking(bookingId, getPdfBit, false, (response: any) => {
                this.blockUI.stop();
                if (response.TransactionObject) {
                    Helpers.LogInfo("in if block", "in if");

                    let pdfLink = `${Utils.GetSalesReviewRemoteServer()}/BookingsV2/GetPrintForm?isPending=${getPdfBit}&id=${this.cryptoService.encryptString(bookingId.toString())}`;
                    let encodeURI = encodeURIComponent(pdfLink);
                    let contactInfo: any;
                    if (customerDetails && customerDetails.contactDetails) {
                        contactInfo = customerDetails.contactDetails.find(
                            (x: any) => x.ContactType === this.pendingAgreementConfig.emailType
                        )?.ContactInformation || null;
                    }
                    else {
                        contactInfo = this.selectedCustomer.mailToEmails;
                    }

                    this.emailContent = new EmailContent(contactInfo, PDFLinkPlaceHolder, isAutoApprove, mode);
                    let mailToStr = this.emailContent.mailTostring.replace(PDFLinkPlaceHolder, encodeURI);
                    mailToStr = mailToStr.replace(TransactionType, type);

                    if (button) {

                        mailToStr = mailToStr.replaceAll("contract", button);
                    }

                    console.log(mailToStr);

                    const message = { type: 'OPEN_EMAIL', data: { emailContent: this.emailContent, mailToStr: mailToStr }, name: 'sales' };
                    window.parent.postMessage(message, "*");

                    location.href = mailToStr;

                    Helpers.LogInfo("before navigation", "in if");

                    if (this.isQuoteConvert && ((mode == "Book" && this.isAutoApproveBooking && IsSameNumber == false) || (mode == "Prepay" && this.isAutoPostPrepay))) {
                        //  this.bookingRequest.isQuoteConverted =this.isQuoteConvert;
                        this.gateway.voidBooking(this.bookingRequest).then((result) => {
                            if (result.TransactionObject) {
                                this.blockUI.stop();
                                this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, Btn: Button, bookingReceiptNumber: bookingReceiptNumber, BookingID: encryptedId, isAutoApprove: getPdfBit, PendingAgreement: PendingAgreement }]);
                            } else {
                                this.blockUI.stop();
                                return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.VoidFailure] }]);
                            }

                        }).catch((e) => {
                            this.blockUI.stop();
                            return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.VoidFailure] }]);
                        })
                    } else {
                        this.blockUI.stop();
                        this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, splits: splits, isSplit: isSplit, mode: mode, Btn: Button, bookingReceiptNumber: bookingReceiptNumber, BookingID: encryptedId, isAutoApprove: getPdfBit, PendingAgreement: PendingAgreement }]);
                    }
                    //this.router.navigate(['bookingcomplete', { mode: mode,Btn: Button, bookingReceiptNumber: bookingReceiptNumber ,BookingID:encryptedId,isAutoApprove:getPdfBit ,PendingAgreement:PendingAgreement   }] );
                    //this.router.navigate(['/bookingcomplete'], {queryParams{ mode: mode,Btn: Button, bookingReceiptNumber: bookingReceiptNumber}} );    
                    // this.router.navigate(['/bookingcomplete'],{queryParams: {mode: mode,Btn: Button, bookingReceiptNumber: bookingReceiptNumber }});
                }
                else {
                    if (this.isQuoteConvert && ((mode == "Book" && this.isAutoApproveBooking && IsSameNumber == false) || (mode == "Prepay" && this.isAutoPostPrepay))) {
                        //  this.bookingRequest.isQuoteConverted =this.isQuoteConvert;
                        this.gateway.voidBooking(this.bookingRequest).then((result) => {
                            if (result.TransactionObject) {
                                this.blockUI.stop();
                                return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.PrintFailure] }]);
                            } else {
                                this.blockUI.stop();
                                return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.VoidFailure, BookingPostingErrorTypes.PrintFailure] }]);
                            }
                        }).catch((e) => {
                            this.blockUI.stop();
                            return this.router.navigate(['bookingcomplete', { mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.VoidFailure, BookingPostingErrorTypes.PrintFailure] }]);
                        })
                    }
                    else {

                        this.blockUI.stop(); return this.router.navigate(['bookingcomplete', { documentNumber: documentNumber, createdDateTime: createdDateTime, mode: mode, Btn: Button, bookingReceiptNumber: response.TransactionMessage, PendingAgreement: this.pendingAgreementConfig.pendingAgreementStatus, errorType: [BookingPostingErrorTypes.PrintFailure] }]);
                    }
                }
            }, (error: any) => {
                Helpers.LogError(error);
                this.blockUI.stop();
                Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                // return this.alertService.error("Agris Service error. Printing Pdf was not successful.");
                this.router.navigate(['bookingcomplete', { mode: mode, Btn: Button, bookingReceiptNumber: bookingReceiptNumber, BookingID: encryptedId, isAutoApprove: getPdfBit, PendingAgreement: PendingAgreement, errorType: BookingPostingErrorTypes.PrintFailure }]);
            });
            // }).catch((err) => {
            //     // console.log(err);
            //     Helpers.LogError(err);
            //     this.blockUI.stop();
            // });
        }
        catch (e) {
            console.log(e);
        }
    }

    validateCreditLimit() {
        if (Number(this.selectedCustomer.salesCreditLimit) == 0) {
            return true;
        }
        else if (this.bookingRequest.totalBookingAmount > Number(this.selectedCustomer.salesCreditLimit)) {
            //this.alertService.warning('Booking exceeds Available Credit.', false, false, false, true);
            return false;
        }
        return true;
    }

    setDefaultDates() {

        var endDateYear = new Date(Date.now()).getFullYear();
        var endDateMonth = new Date(Date.now()).getMonth() + 1;
        var endDateDate = new Date(Date.now()).getDate();

        this.bookingRequest.startDate = new Date(Date.now());
        this.minDate = new Date(Date.now());
        this.bookingRequest.endDate = new Date(endDateYear, endDateMonth, endDateDate);
    }

    setDefaultDatesForItems(Item: any) {

        var endDateYear = new Date(Date.now()).getFullYear();
        var endDateMonth = new Date(Date.now()).getMonth() + 1;
        var endDateDate = new Date(Date.now()).getDate();

        Item.startDate = new Date(Date.now());

        Item.endDate = new Date(endDateYear, endDateMonth, endDateDate);
        return Item;
    }


    setDateFormat() {

        var startDT = new Date(this.bookingRequest.startDate);
        var startDateYear = startDT.getFullYear();
        var startDateMonth = startDT.getMonth();
        var startDateDate = startDT.getDate();
        var startDateHour = new Date().getHours();
        var startDateMin = new Date().getMinutes();
        var startDateSec = new Date().getSeconds();
        this.bookingRequest.startDate = new Date(startDateYear, startDateMonth, startDateDate, startDateHour, startDateMin, startDateSec);


        var endDT = new Date(this.bookingRequest.endDate);
        var endDateYear = endDT.getFullYear();
        var endDateMonth = endDT.getMonth();
        var endDateDate = endDT.getDate();
        this.bookingRequest.endDate = new Date(endDateYear, endDateMonth, endDateDate, startDateHour, startDateMin, startDateSec);
        this.bookingRequest.bookingItems.forEach((item) => {
            var startDT = new Date(item.startDate);
            var startDateYear = startDT.getFullYear();
            var startDateMonth = startDT.getMonth();
            var startDateDate = startDT.getDate();
            var startDateHour = new Date().getHours();
            var startDateMin = new Date().getMinutes();
            var startDateSec = new Date().getSeconds();
            item.startDate = new Date(startDateYear, startDateMonth, startDateDate, startDateHour, startDateMin, startDateSec);

            var endDT = new Date(item.endDate);
            var endDateYear = endDT.getFullYear();
            var endDateMonth = endDT.getMonth();
            var endDateDate = endDT.getDate();
            item.endDate = new Date(endDateYear, endDateMonth, endDateDate, startDateHour, startDateMin, startDateSec);
        })
    }

    validateDates() {
        this.alertService.clear();
        var endDateYear = new Date(Date.now()).getFullYear();
        var endDateMonth = new Date(Date.now()).getMonth();
        var endDateDate = new Date(Date.now()).getDate();
        var currentDate = new Date(endDateYear, endDateMonth, endDateDate);

        if ((this.bookingRequest.startDate < currentDate) || (this.bookingRequest.endDate < currentDate)) {
            this.alertService.error("Invalid Check date", false, true);
            return false;
        }

        if (this.bookingRequest.startDate >= this.bookingRequest.endDate) {
            // this.alertService.error("Invalid Check date", false, true);
            this.bookingRequest.endDate = this.bookingRequest.startDate;
            return false;
        }

        if (this.bookingRequest.bookingPrepay && this.bookingRequest.bookingPrepay.chequeDate < currentDate) {
            this.alertService.error("Invalid Check date", false, true);
            return false;
        }

        return true;
    }

    validateItemDate(selectdItem: ItemDetails) {
        this.alertService.clear();
        var endDateYear = new Date(Date.now()).getFullYear();
        var endDateMonth = new Date(Date.now()).getMonth();
        var endDateDate = new Date(Date.now()).getDate();
        var currentDate = new Date(endDateYear, endDateMonth, endDateDate);

        if ((selectdItem.startDate < currentDate)
            || (selectdItem.startDate > selectdItem.endDate)
            || (new Date(selectdItem.startDate).getFullYear() == new Date(selectdItem.endDate).getFullYear()
                && new Date(selectdItem.startDate).getMonth() == new Date(selectdItem.endDate).getMonth()
                && new Date(selectdItem.startDate).getDate() == new Date(selectdItem.endDate).getDate()
            )
        ) {
            this.alertService.error("Invalid date", false, true);
            return false;
        }
        return true;
    }

    displayItemsTable() {
        this.displayedColumns = ['location', 'quantity', 'name', 'prepaidAmount', 'startDate', 'endDate'];
        //this.displayedColumns = ['quantity', 'name', 'prepaidAmount', 'startDate', 'endDate'];
        this.dataSource = new MatTableDataSource(this.addedItems);
    }

    receiveCustomers($event) {
        // this.titleService.setTitle("Booking Search");
        this.selectedFarmAndField = 'Not Selected.';
        this.customers = $event.customer;
        this.customerRequest = $event.request;
        this.customerSearchDescription = `Search filters -  NameId: ${this.customerRequest.nameId ? this.customerRequest.nameId : 'All'},Name Desc: ${this.customerRequest.name ? this.customerRequest.name : 'All'}, City: ${this.customerRequest.city ? this.customerRequest.city : 'All'}, Phone: ${this.customerRequest.phoneNumber ? this.customerRequest.phoneNumber : 'All'}`
        this.showBackToTopForCustomers = $event.customer && $event.customer.length >= 25;
        this.isfarmAndFields = false;
    }


    receiveSelectedCustomer($event): Promise<any> {
        return new Promise((resolve, fail) => {
            this.showFarmAndFields = this.isProUser && !this.isFromQuote;
            this.selectedCustomer = $event.customerDetails;
            this.blockUI.start();
            this.customerServiceProvider.GetCustomerCreditDetails(this.selectedCustomer.nameId).then((credit: CustomerCredit) => {
                this.stopBlockUI();
                // this.blockUI.stop();
                this.customerSearchDescription = this.selectedCustomer.name;
                this.credit = credit;//$event.customerCredit;
                this.bookingRequest.creditInfo = this.credit;
                this.bookingRequest.customerInfo = this.selectedCustomer;
                this.customerPriceLevel = this.selectedCustomer.priceLevel;
                if (this.addedItems.length > 0) {
                    this.recalculateAddedItem();
                }
                this.customers = null;
                this.showBackToTopForCustomers = false;
                if (Number(this.selectedCustomer.salesCreditLimit) < 0) {
                    this.customerLimitType = -1
                } else if (Number(this.selectedCustomer.salesCreditLimit) == 0) {
                    this.customerLimitType = 0
                } else {
                    this.customerLimitType = Number(this.selectedCustomer.salesCreditLimit);
                }
                this.setStep(1);
                resolve(true);
            }).catch((error) => {
                // console.log(error);
                Helpers.LogError(error);
                this.stopBlockUI();
                Sentry.captureMessage("Handled Error" + error);
                if (error.Message)
                    this.alertService.error(error.Message);
                fail(error);
            });
        });
    }

    receiveItems($event) {
        this.itemsDetails = $event;
        this.showBackToTopForItems = $event && $event.length >= 25;
    }

    async itemSelection($event, isFromEdit = false) {


        // // Notify the child to cancel ongoing HTTP requests
        // if (this.itemSearchComponent) {
        //     this.itemSearchComponent.cancelRequests();
        // }
        // this.requestHelper.cancelRequests();
        // // Handle the selected item logic
        // this.selectedItem = $event;
        // console.log('Selected item:', $event);

        localStorage.setItem('BlockLocation', 'true');

        this.selectedItem = $event;
        await this.GetProductCategoryDateRange();
        if (!this.selectedItem.isAllowedEdit) {
            utils.confirmationDialog('Warning', 'You are not allowed to edit Quote item', 'Confirm', (result) => {
                if (result == 'Confirm') {
                }
            }, false);
        }

        if (!isFromEdit) {
            this.setBeginingAndEndDateForItem(this.selectedItem);
            this.selectedItem.itemBalance.Location = Utils.getLocation();
        }
        this.selectedItem.selectedItemLocations = await this.getItemLocations(this.selectedItem.itemId);
        if (this.selectedItem.itemBalance.Location == '') {
            utils.confirmationDialog('Warning', 'Please set location first from setting page', 'Confirm', (result) => {
                if (result == 'Confirm') {
                    this.router.navigate(['/settings'], { queryParams: { LocationCode: false } });

                }


            }, false);
        }
        // this.selectedItem.selectedItemLocations = await  this.getItemLocations(this.selectedItem.itemId);
        //  var Itemlocation = this.QuoteItemLocation ;    

        //  if (Itemlocation && this.isQuoteConvert && isFromEdit){
        //     this.selectedItem.itemBalance.Location =  Itemlocation["quote"].items.find(x=>x["ProductId"] == this.selectedItem.itemId).Location;
        //  }
        //  else if(this.isQuoteConvert == false && isFromEdit == true){
        //     this.selectedItem.itemBalance.Location =this.selectedItem.itemBalance.Location ;
        //  }             
        //  else{
        //     this.selectedItem.itemBalance.Location =Utils.getLocation();
        //  }

        // console.log(selectedItem);


        this.showItemDetails = true;
        this.itemNameForDetails = $event.name;
        this.itemsDetails = null;
        this.showBackToTopForItems = false;
        this.setStep(4);
    }

    async getItemLocations(itemId: string): Promise<any[]> {
        this.blockUI.start();
        let locations: any[] = [];
        var mergeLocations = [];
        try {
            locations = await this.itemSerivce.getOnhandForItemOnLocationFromAgris(itemId, true);
            if (locations && locations.length) {
                let locationCodes = locations.map(x => x.Location);
                locationCodes = [...new Set(locationCodes)];

                locationCodes.forEach((code: any, index: number) => {
                    let mergeLocation: any = {};
                    let OnHandQuantity = locations.filter(x => x.Location == code).map(y => y.OnHandQuantity);
                    mergeLocation.OnHandQuantity = OnHandQuantity.reduce((a: number, b: number) => a + b, 0);

                    let PositionQuantity = locations.filter(x => x.Location == code).map(y => y.PositionQuantity);
                    mergeLocation.PositionQuantity = PositionQuantity.reduce((a: number, b: number) => a + b, 0);

                    mergeLocation.Location = code;

                    let LocationDV = locations.filter(x => x.Location == code).map(y => y.LocationDV);
                    mergeLocation.LocationDV = LocationDV[0];
                    mergeLocation.LocationDV = mergeLocation.LocationDV.replace(mergeLocation.Location, "");


                    mergeLocations.push(mergeLocation);
                });
            }
            return mergeLocations;
        }
        catch (ex) {
            console.log(ex);
            return [];
        }
        finally {
            this.blockUI.stop();
        }
    }

    settingsCheck() {
        if (utils.getLocation() == undefined) {
            return true;
        }
        else {
            return false;
        }
    }
    onFocus($event) {
        let value = $event.target.value;
        if (value === 0 || value === '0') {
            this.selectedItem.itemBalance.OnHandQuantity = null;
            $event.target.value = null;
        }
    }
    onBlur($event) {
        let value = $event.target.value;
        if (value === null || value === '') {
            this.selectedItem.itemBalance.OnHandQuantity = 0;
            $event.target.value = 0;
        }
    }
    // moveSearchButton() {
    //     var width = document.getElementById("leftSpace").style.marginLeft;
    //     var element = document.getElementById("nextButton");
    //     var nextButtonRow = document.getElementById("nextButtonRow");
    //     var itemDetailButtonRow = document.getElementById("itemDetailButtonRow");
    //     var itemUpdateButtonRow = document.getElementById("itemUpdateButtonRow");
    //     var finishButtonRow = document.getElementById("finishButtonRow");

    //     if (this.currentWidth < 768) {
    //         if (element != null) {
    //             element.setAttribute("style", "margin-left: 0px");
    //             nextButtonRow.setAttribute("class", "text-right");
    //         }
    //         if (itemDetailButtonRow != null) {
    //             itemDetailButtonRow.setAttribute("style", "margin-left: 0px");
    //             itemDetailButtonRow.setAttribute("class", "text-right");
    //         }
    //         if (itemUpdateButtonRow != null) {
    //             itemUpdateButtonRow.setAttribute("style", "margin-left: 0px");
    //             itemUpdateButtonRow.setAttribute("class", "text-right");
    //         }
    //         if (finishButtonRow != null) {
    //             finishButtonRow.setAttribute("style", "");
    //             finishButtonRow.setAttribute("class", "text-right");
    //         }
    //     }
    //     else {
    //         if (element != null) {
    //             nextButtonRow.removeAttribute("class");
    //             element.setAttribute("style", "margin-left: " + width);
    //         }
    //         if (itemDetailButtonRow != null) {
    //             itemDetailButtonRow.removeAttribute("class");
    //             itemDetailButtonRow.setAttribute("style", "margin-left: " + width);
    //         }
    //         if (itemUpdateButtonRow != null) {
    //             itemUpdateButtonRow.removeAttribute("class");
    //             itemUpdateButtonRow.setAttribute("style", "margin-left: " + width);
    //         }
    //         finishButtonRow.removeAttribute("class");
    //         finishButtonRow.setAttribute("style", "margin-left: " + width + ";text-align: left !important");
    //     }
    // }
    onResize(event) {
        this.currentWidth = event.target.innerWidth;
    }
    book() {
        if (this.totalItemsCount == 0) {
            utils.confirmationDialog('Warning', 'Please select an item to proceed', 'Close', (result) => {

            }, false);
        }
        else {
            this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
                this.blockUI.stop();
                this.isBookEnabled = true;
                this.setStep(6);
            }).catch((err) => {
                // console.log(err);
                Helpers.LogError(err);
                this.blockUI.stop();
            });
        }
    }
    quote() {

        if (this.totalItemsCount == 0) {
            utils.confirmationDialog('Warning', 'Please select an item to proceed', 'Close', (result) => {

            }, false);
        } else {

            this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
                this.blockUI.stop();
                this.isQuoteEnabled = true;
                this.setStep(8);
            }).catch((err) => {
                // console.log(err);
                Helpers.LogError(err);
                this.blockUI.stop();
            });
        }






    }
    prepay() {

        if (this.totalItemsCount == 0) {
            utils.confirmationDialog('Warning', 'Please select an item to proceed', 'Close', (result) => {

            }, false);
        } else {
            this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
                this.blockUI.stop();
                this.isPrepayEnabled = true;
                this.setStep(7);
                this.bookingRequest.bookingPrepay.chequeAmount = this.bookingRequest.totalBookingAmount;
            }).catch((err) => {
                Helpers.LogError(err);
                // console.log(err);
                this.blockUI.stop();
            });
        }


    }
    receiveCancelBook() {
        this.isBookEnabled = false;
        this.step = 5;
    }
    receiveCancelQuote() {
        this.isQuoteEnabled = false;
        this.step = 5;
    }
    receiveCancelPrepay() {
        this.isPrepayEnabled = false;
        this.step = 5;
    }
    getPermissions() {
        let per = localStorage.getItem('UserPermission');
        if (per) {
            let permissions = JSON.parse(this.cryptoService.dencryptString(per));
            permissions.forEach(permission => {
                if (permission.SecurityOption == "RIMPT" && parseInt(permission.SecurityLevel) > 1) {
                    this.isPrepayAllow = true;
                }
                if (permission.SecurityOption == "KIMPT" && parseInt(permission.SecurityLevel) > 1) {
                    this.isBookAllow = true;
                }
            });
        }
    }
    async getPricision(): Promise<any> {
        try {
            const response = await this.appSetting.GetDecimalPricision();
            this.unitPricePrecision = response.UnitPricePrecision;
            this.productQuantityPrecision = response.ProductQuantityPrecision;
            // this.blockUI.stop();
            return response;
        } catch (error: any) {
            if (error) {
                this.alertService.error(error.Message);
            }
            this.blockUI.stop();
            throw error; // rethrow if needed by caller
        }
    }

    async GetBookingPrograms(): Promise<void> {
        try {
            const response = await this.appSetting.GetAppSettingsFromASR(ASRAppSettings.BookingProgramSettings);
            const data = response.TransactionObject;

            this.bookingProgramDropdownItems = data.filter(
                x => x.Name !== 'BookingProgramSettingStatus' && x.Name !== 'BookingProcess'
            );

            const bookingProgramStatusSettings = data.find(x => x.Name === 'BookingProgramSettingStatus');
            if (bookingProgramStatusSettings) {
                this.bookingProgramDropdownStatus = JSON.parse(bookingProgramStatusSettings.Value);
                this.remarksCommenLimit = this.bookingProgramDropdownStatus ? 250 : 300;
            }

            const bookingProgramRequired = data.find(x => x.Name === 'BookingProcess');
            if (bookingProgramRequired) {
                this.bookingProgramDropdownRequired = bookingProgramRequired.Value;
            }

            // this.blockUI.stop(); // Uncomment if you want to manually stop the loader here
        } catch (error: any) {
            if (error) {
                this.alertService.error(error.Message);
            }
        }
    }


    async GetProductCategoryDateRange() {
        this.blockUI.start();
        await this.appSetting.GetAppSettingsFromASR(ASRAppSettings.ProductCategoryDateRange).then((response) => {
            this.productCategoryDateRange = response.TransactionObject;

            // this.blockUI.stop();

        }).catch((error) => {
            if (error)
                this.alertService.error(error.Message);
            this.blockUI.stop();
        })
    }


    async GetPendingAgreementSettings(): Promise<void> {
        try {
            const response = await this.appSetting.GetAppSettingsFromASR(ASRAppSettings.PendingAgreementsConfiguration);
            const data = response.TransactionObject;

            if (data.length) {
                const findSetting = (name: string) => data.find((x: any) => x.Name === name);

                const settingStatus = findSetting(PendingAgreementsConfiguration.PendingAgreementStatus);
                this.pendingAgreementConfig.pendingAgreementStatus = settingStatus?.Value
                    ? JSON.parse(settingStatus.Value)
                    : false;

                const selectedEmailType = findSetting(PendingAgreementsConfiguration.SelectedEmailType);
                this.pendingAgreementConfig.emailType = selectedEmailType?.Value
                    ? selectedEmailType.Value.split('-')[0].trim()
                    : "";

                const selectedBookingStatus = findSetting(PendingAgreementsConfiguration.SelectedPendingBookingStatus);
                if (selectedBookingStatus) {
                    this.pendingAgreementConfig.pendingBookingStatus = selectedBookingStatus.Value;
                    this.pendingAgreementConfig.pendingBookingStatusDescription =
                        this.pendingAgreementConfig.pendingAgreementStatus ? "Pending Booking" : "";
                }

                const selectedPrepayStatus = findSetting(PendingAgreementsConfiguration.SelectedPendingPrepayStatus);
                if (selectedPrepayStatus?.Value) {
                    this.pendingAgreementConfig.pendingPrepayStatus = selectedPrepayStatus.Value;
                    this.pendingAgreementConfig.pendingPrepayStatusDescription =
                        this.pendingAgreementConfig.pendingAgreementStatus ? "Pending Prepay" : "";
                }

                const selectedQuoteStatus = findSetting(PendingAgreementsConfiguration.SelectedPendingQuoteStatus);
                if (selectedQuoteStatus?.Value) {
                    this.pendingAgreementConfig.pendingQuoteStatus = selectedQuoteStatus.Value;
                    this.pendingAgreementConfig.pendingQuoteStatusDescription =
                        this.pendingAgreementConfig.pendingAgreementStatus ? "Pending Quote" : "";
                }

                const SignatureRequiredStatus = findSetting(PendingAgreementsConfiguration.SignatureRequiredStatus);
                if (SignatureRequiredStatus?.Value) {
                    const value = SignatureRequiredStatus.Value;
                    this.pendingAgreementConfig.PendingSignatureRequiredStatus = value;
                    this.BookingSignatureRequiredStatus = value.toLowerCase() === 'true';
                }

                const ButtonQuote = findSetting(PendingAgreementsConfiguration.ButtonQuote);
                if (ButtonQuote?.Value) {
                    this.pendingAgreementConfig.ButtonQuote = ButtonQuote.Value;
                    this.QuoteButtonName = ButtonQuote.Value;
                    if (this.isQuoteUpdate) {
                        this.titleService.setTitle("Update " + this.QuoteButtonName);
                    }
                } else {
                    this.QuoteButtonName = "Quote";
                }

                const ButtonPrepay = findSetting(PendingAgreementsConfiguration.ButtonPrepay);
                this.PrepayButtonName = ButtonPrepay?.Value || "Prepay";
                this.pendingAgreementConfig.ButtonPrepay = ButtonPrepay?.Value;

                const ButtonBooking = findSetting(PendingAgreementsConfiguration.ButtonBooking);
                this.BookingButtonName = ButtonBooking?.Value || "Booking";
                this.pendingAgreementConfig.ButtonBooking = ButtonBooking?.Value;

                const HideBooking = findSetting(PendingAgreementsConfiguration.HideBookingButton);
                this.HideBookingButton = HideBooking?.Value === "true";

                const HidePrepay = findSetting(PendingAgreementsConfiguration.HidePrepayButton);
                this.HidePrepayButton = HidePrepay?.Value === "true";

                const HideQuote = findSetting(PendingAgreementsConfiguration.HideQuoteButton);
                this.HideQuoteButton = HideQuote?.Value === "true";

                const remarkNumberForBookingProgram = findSetting(PendingAgreementsConfiguration.RemarkNumberForBookingProgram);
                if (remarkNumberForBookingProgram?.Value) {
                    this.pendingAgreementConfig.RemarkNumberForBookingProgram = remarkNumberForBookingProgram.Value;
                }

                const remarkNumberForFarmAndField = findSetting(PendingAgreementsConfiguration.RemarkNumberForFarmAndField);
                if (remarkNumberForFarmAndField?.Value) {
                    this.pendingAgreementConfig.RemarkNumberForFarmAndField = remarkNumberForFarmAndField.Value;
                }
            }
        } catch (error: any) {
            if (error) {
                this.alertService.error(error.Message);
            }
        }
    }


    openBookings() {
        this.blockUI.start();
        this.bookingService.GetOpenBooking(this.selectedCustomer.nameId).then((bookings) => {
            this.blockUI.stop();
            bookings.NameDescription = this.selectedCustomer.name;
            const dialogRef = this.dialog.open(OpenBookingComponent, {
                width: window.innerWidth + 'px',
                maxHeight: window.innerHeight - 100 + 'px',
                data: bookings
            });
            dialogRef.afterClosed().subscribe(result => {
                Helpers.LogInfo(`Dialog result: ${result}`);
                // console.log(`Dialog result: ${result}`);
            });
            this.closeDialogService.emitRegisterDialog(dialogRef);
        }).catch((error) => {
            this.blockUI.stop();
            Helpers.LogError(error);
            // console.log(error);
            if (error.Code != 404)
                Sentry.captureMessage("Handled Error" + error);


            const dialogRef = this.dialog.open(OpenBookingComponent, {
                width: window.innerWidth + 'px',
                data: { NameDescription: this.selectedCustomer.name, Message: error.Code == 404 ? "There are no open bookings for this customer." : error.Message }
            });
            dialogRef.afterClosed().subscribe(result => {
                // console.log(`Dialog result: ${result}`);
                Helpers.LogInfo(`Dialog result: ${result}`);
            });
            this.closeDialogService.emitRegisterDialog(dialogRef);
            this.blockUI.stop();
        })
    }

    openPrepays() {
        this.blockUI.start();
        this.bookingService.GetOpenPrepays(this.selectedCustomer.nameId).then((prepays) => {
            this.blockUI.stop();
            prepays.NameDescription = this.selectedCustomer.name;
            const dialogRef = this.dialog.open(OpenPrepaysComponent, {
                width: window.innerWidth + 'px',
                maxHeight: window.innerHeight - 100 + 'px',
                data: prepays
            });

            dialogRef.afterClosed().subscribe(result => {
                // console.log(`Dialog result: ${result}`);
                Helpers.LogInfo(`Dialog result: ${result}`);
            });
            this.closeDialogService.emitRegisterDialog(dialogRef);
        }).catch((error) => {
            // console.log(error);
            Helpers.LogError(error);
            Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
            this.blockUI.stop();
            const dialogRef = this.dialog.open(OpenPrepaysComponent, {
                width: window.innerWidth + 'px',
                data: { NameDescription: this.selectedCustomer.name, Message: error.Code == 404 ? "There are no open prepays for this customer." : error.Message }
            });

            dialogRef.afterClosed().subscribe(result => {
                // console.log(`Dialog result: ${result}`);
                Helpers.LogInfo(`Dialog result: ${result}`);
            });
            this.closeDialogService.emitRegisterDialog(dialogRef);

            //this.alertService.error(error.Message);
            this.blockUI.stop();
        })
    }

    backToTop() {
        this.scroll.scrollToPosition([0, 0]);
    }


    openBookingsComplete() {
        Helpers.LogInfo("before navigation", "openBookingsComplete");

        //  location.href = "bookingcomplete?mode=Order;bookingReceiptNumber=18666";

        ///bookingcomplete;mode=Book;Btn=BOOKING;bookingReceiptNumber=19640
        //this.router.navigate(['bookingcomplete', { mode: 'Book',Btn: 'booking', bookingReceiptNumber: '19640'}] );  
    }

    getRemarksLimit(type: any) {

        //remarks 6 = Pending Agreement Status (Booking Number)
        //remarks 5 = Book Program 
        //remarks 4 = Farm and Field value

        // let remarksLength = 300;

        // if (this.bookingProgramDropdownStatus == true && this.pendingAgreementConfig.pendingAgreementStatus == true && type == "Book")
        //     remarksLength = 200;
        // else if (this.bookingProgramDropdownStatus == true && this.pendingAgreementConfig.pendingAgreementStatus == true && type == "Prepay")
        //     remarksLength = 250;
        // else if (this.bookingProgramDropdownStatus == false && this.pendingAgreementConfig.pendingAgreementStatus == true)
        //     remarksLength = 250;
        // else if (this.bookingProgramDropdownStatus == true && this.pendingAgreementConfig.pendingAgreementStatus == false)
        //     remarksLength = 250;

        // if (this.isProUser == true) {
        //     remarksLength = remarksLength - 100;
        // }


        // if (this.bookingProgramDropdownStatus == true && this.pendingAgreementConfig.pendingAgreementStatus == true && type == "Book")
        //     return 200;
        // else if (this.bookingProgramDropdownStatus == true && this.pendingAgreementConfig.pendingAgreementStatus == true && type == "Prepay")
        //     return 250;
        // else if (this.bookingProgramDropdownStatus == false && this.pendingAgreementConfig.pendingAgreementStatus == true)
        //     return 250;
        // else if (this.bookingProgramDropdownStatus == true && this.pendingAgreementConfig.pendingAgreementStatus == false)
        //     return 250;
        // else
        //     return 300;

        let remarksLength = 150;

        // if (this.isProUser == true) {
        //     remarksLength = remarksLength - 50;
        // }



        return remarksLength;
    }





    async getUsersPermission(): Promise<void> {
        try {
            const permissions = await this.bookingService.GetUserPermissions();
            this.isAutoPostPrepay = false;
            this.isAutoApproveBooking = false;

            const currentUsername = JSON.parse(localStorage.getItem('agrisLicense') || '{}')?.username;

            permissions.forEach(permission => {
                if (permission.AssignedUserId.trim() === currentUsername) {
                    this.isAutoPostPrepay = permission.AutoApprovePrepay;
                    this.isAutoApproveBooking = permission.AutoApproveBooking;
                }
            });
        } catch (error) {
            console.error("Failed to get user permissions:", error);
            // Optionally show a user-facing message here
        }
    }

    onEnter() {
        if (this.selectedItem.itemBalance.OnHandQuantity == 0 || this.selectedItem.amount == 0) {
            return;
        } else {
            this.addItem(false, false);
        }
    }

    async onLocationChange() {


        console.log(this.selectedItem);
        let locationInfo = this.selectedItem.selectedItemLocations.find(x => x.Location == this.selectedItem.itemBalance.Location);
        Object.assign(this.selectedItem.itemBalance, locationInfo);
        this.selectedItem.itemBalance.OnHandQuantity = 0;
        this.selectedItem.branch = locationInfo.Location;
        this.selectedItem.location = locationInfo.Location;
        console.log(this.selectedItem);
        this.updateItemDetails();
        // console.log(this.selectedItem);
    }

    async updateItemDetails() {
        let newItemDetails: any = await this.itemSerivce.getItemDetailsByLocation(this.selectedItem.name, this.selectedItem.itemBalance.Location);
        if (newItemDetails) {
            this.selectedItem.priceLevel1 = newItemDetails.SellingPrice1;
            this.selectedItem.priceLevel2 = newItemDetails.SellingPrice2;
            this.selectedItem.price = this.customerPriceLevel == '2' ? this.selectedItem.priceLevel2 : this.selectedItem.priceLevel1;
            // this.selectedItem.amount = Number((this.selectedItem.price * this.selectedItem.itemBalance.OnHandQuantity));
        }
    }
    getFarmAndField() {
        if (this.isProUser) {
            this.isfarmAndFields = true;
            this.nextStep();
        } else {
            this.nextStep();
            this.nextStep();
        }
    }
    receiveFarmAndFields(response) {
        this.selectedFarmAndField = response.name;
        this.bookingRequest.farm = response.farmCode;
        this.bookingRequest.farmName = response.farmName;
        this.bookingRequest.field = response.fieldCode;
        this.bookingRequest.fieldName = response.fieldName;
        this.bookingRequest.clientId = response.clientId;
        this.splits = response.splits;
        this.showFarmAndFields = true;
        if (this.selectedFarmAndField != 'No farm and fields available.')
            this.nextStep();
    }
    getIsDifferentLocationItemSelected() {
        const groupedItems = utils.groupBy(this.addedItems, 'branch');
        if (Object.entries(groupedItems).length > 1)
            return true;
        else
            return false;
    }
    ngOnDestroy() {
        localStorage.removeItem('BlockLocation');
    }
}

